import * as marietta from '../../../../marietta';
import { Dialog } from '../../../core/view';

export class PinItemChangeDialog extends Dialog {

    private static readonly HEADING_CURRENT_ITEM: string = '現在紐づいているアイテム';

    private static readonly HEADING_TARGET_ITEM: string = '紐づけるアイテム';

    public isEditMode: boolean = false; // 付帯工事編集

    public isWizard: boolean = false;

    // true: 3D/2D空間でこれから紐づけようとしているアイテムの情報を表示する（見出しが「紐づけるアイテム」になる）
    public isTargetItem: boolean = false;

    public itemName: string = null;

    public roomName: string= null;

    constructor(draggable: boolean) {
        super(draggable);
    }

    public buildContent(): void {
        const id = 'PinItemChangeDialog';
        const title = (marietta.webcad.WebCADGlobal.language === 'jp') ?
                        '確認' : 'Confirmation of changes to tied items';
        const heading = this.isTargetItem ? PinItemChangeDialog.HEADING_TARGET_ITEM : PinItemChangeDialog.HEADING_CURRENT_ITEM;

        const contents = `
            <div class="pinItemChangeContainer">
                ${this.isEditMode ? '<div class="explainContents">付帯工事の情報を保存して、<br>紐づけるアイテムを変更しますか？</div>'
                                  : '<div class="explainContents">紐づけるアイテムを変更しますか？</div>'}
                <div class="itemContents">
                    <h3>${heading}</h3>
                    <div class="lineContents"><label style="margin-left: -26px">アイテム名： </label><label>${this.itemName}</label></div>
                    <div class="lineContents"><label>部屋名： </label><label>${this.roomName ?? ''}</label></div>
                </div>
            </div>
        `;

        const footer = `
            <button id="btnChange"><span class="jp">変更</span><span class="en">OK</span></button>
            <button id="btnClose"><span class="jp">閉じる</span><span class="en">Change</span></button>
        `;

        this.createDialog(id, title, contents, footer);

        document.getElementById('btnChange')?.addEventListener('click', this.confirmItemChangeBtn);
        document.getElementById('btnClose')?.addEventListener('click', this.close);
    }

    public closeEvent() {
        super.closeEvent();

        if (this.isWizard) {
            document.getElementById('modalBg').style.display = 'none';
        }
    }

    private confirmItemChangeBtn = () => {
        this.close();
        if (this.isWizard) {
            this.callBack(this.isWizard);
            return;
        }

        this.callBack();
    }

}
